/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {Component, Prop, Vue} from 'vue-property-decorator'
import {AnalysisVO} from '@/valueObjects/AnalysisVO'
import MessageBox from '@/components/shared/MessageBox'
import {SUCCESS_MESSAGE_TYPE} from '@/utils/constants'

@Component({
    components: {
        MessageBox,
    },
})
export default class AnalysisVirus extends Vue {
    private message = 'No virus found by virus total.'
    private messageType = SUCCESS_MESSAGE_TYPE

    @Prop()
    private analysis: AnalysisVO
    @Prop()
    private isFinished: boolean

    private hasVirus_vt() {
        if (!this.analysis.staticReport) {
            return false
        }

        if (!this.analysis.staticReport.virustotal_viruses || this.analysis.staticReport.virustotal_viruses === 'undefined') {
            return false
        }
        return this.analysis && this.analysis.staticReport && this.analysis.staticReport.virustotal_viruses.length > 0
    }

    private hasVirus_pfav() {
        //console.log(this.analysis.staticReport.pfav_viruses)
        if (!this.analysis.staticReport) {
            return false
        }

        if (!this.analysis.staticReport.pfav_viruses || this.analysis.staticReport.pfav_viruses === 'undefined') {
            return false
        }
        return true
    }

    private clearMessage() {
        this.message = ''
    }
}
